import styled from '@emotion/styled';
import React from 'react';
import {mixinFocus, mixinSVGIcon} from 'webapp-lib/styling';

import {Props} from '.';

export const Input = styled.input`
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  color: var(--color-core-black);
  height: 100%;
  flex-grow: 1;
  border: none;
  outline: none;
  width: 100%;

  ::placeholder {
    color: var(--color-core-dark-grey);
  }
`;

export const IconWrapper = styled(
  React.forwardRef(
    (
      props: React.ButtonHTMLAttributes<HTMLButtonElement>,
      ref: React.Ref<HTMLButtonElement>
    ): React.ReactElement => <button ref={ref} {...props} type='button' />
  )
)`
  cursor: pointer;
  display: flex;
  height: 100%;
  border: none;
  justify-content: center;
  align-items: center;
  margin-top: var(--gutter-tiny);
  margin-right: var(--gutter-tiny);
  border-radius: 4px;
  padding: var(--gutter-very-tiny);
  width: 22px;
  height: 22px;
  background-color: var(--color-core-white);

  :focus svg {
    ${mixinFocus}
  }
`;

export const SearchIcon = styled(IconWrapper)`
  svg {
    ${mixinSVGIcon}
  }
`;

export const ClearIcon = styled(IconWrapper)`
  border-radius: 2px;
  svg {
    width: 8px;
    height: 8px;
    fill: var(--color-core-link);
  }

  :focus {
    border-radius: var(--focus-border-radius);
    border: var(--focus-border-width) solid var(--color-core-keyboardfocus);
    > svg {
      box-shadow: none;
      border: none;
    }
  }
`;

export const StyledSearchBar = styled.div<Props>`
  display: flex;
  justify-content: flex-end;
  height: 32px;
  border: thin solid var(--color-core-dark-grey);
  border-radius: 2px;

  :focus-within,
  :focus {
    border: thin solid var(--color-state-active);
  }

  ${Input} {
    padding: var(--gutter-tiny) 0 var(--gutter-tiny) var(--gutter-little);
  }

  ${SearchIcon} {
    ${({value}): string => (value ? 'display: none;' : '')}
  }

  ${ClearIcon} {
    ${({value}): string => (value ? '' : 'display: none;')}
    cursor: pointer;
  }

  ${IconWrapper} svg {
    fill: ${({value}): string =>
      value ? 'var(--color-state-active)' : 'var(--color-core-dark-grey)'};
  }
`;
